import * as Yup from 'yup';

export const ExitDispatcherSchema = Yup.object().shape({
    exitDate: Yup.date().required('Exit date is required').typeError('Please select a valid date'),
    exitReason: Yup.string().oneOf(['Voluntary Exit', 'End of contract', 'Termination'], 'Please select a valid reason').required('Reason for exit is required'),
    rehireEligibility: Yup.string().oneOf(['Yes', 'No'], 'Please select an option').required('Rehire eligibility is required'),
    exitComments: Yup.string().trim().min(10, 'Review must be at least 10 characters').required('Review is required'),
});

export type ExitDispatcherDataType = Yup.InferType<typeof ExitDispatcherSchema>;

type InitialValues = {
    exitDate: string;
    exitReason: string;
    rehireEligibility: string;
    exitComments: string;
};

export const ExitDispatcherInitialValues: InitialValues = {
    exitDate: '',
    exitReason: '',
    rehireEligibility: '',
    exitComments: '',
};

export interface ExitDispatcherInterface {
    exitDate: string;
    exitReason: string;
    rehireEligibility: string;
    exitComments: string;
}
